export const docCopy = {
  doc_layout_title: "TypeScript学習の第一歩",
  doc_layout_description:
    "TypeScriptスタータープロジェクトを見つけましょう: AngularからReact、Node.js、そしてCLIまで",
  doc_bootstrap_title: "TypeScriptプロジェクトを始めるためのツール",
  doc_bootstrap_description:
    "CLI、Webアプリケーション、APIそしてネイティブアプリケーションを作るためのツールチェーン",
  doc_headline: "学習のためのリソース",
  doc_headline_ts_for_js_title: "TS for JS", // TODO: Remove, unused
  doc_headline_ts_for_js_blurb:
    "An overview of TypeScript for engineers with a JavaScript background", // TODO: Remove, unused
  doc_headline_ts_first_title: "Start with TS", // TODO: Remove, unused
  doc_headline_ts_first_blurb:
    "A beginners introduction to JavaScript and TypeScript", // TODO: Remove, unused
  doc_headline_handbook_title: "Handbook", // TODO: This is not actually used on headline section, should be moved to the doc_learn section
  doc_headline_handbook_blurb: "The TypeScript language reference",
  doc_headline_examples_title: "Examples", // TODO: Remove, unused
  doc_headline_examples_blurb: "Comprehensive hands-on playground tutorials", // TODO: Remove, unused
  doc_start_a_project: "新しいプロジェクトを始める",
  doc_start_a_project_desc:
    "TypeScriptはJavaScriptのスーパーセットなので、デフォルトのテンプレートはありません。その代わりに、いくつかのプロジェクトはTypeScriptの初期セットアップのテンプレートを提供しています。以下のプロジェクトはTypeScriptをサポートするテンプレートを提供しています。",
  doc_node_npm: "npm",
  doc_node_npm_tsdx_blurb: "TypeScriptのライブラリ作成のための設定不要のツール",
  doc_node_npm_oclif_blurb: "ユーザーが気に入ってくれるコマンドラインツールの作成",
  doc_node_npm_gluegun_blurb:
    "TypeScriptコマンドラインアプリケーション作成のためのすばらしいツールキット",
  doc_frameworks: "Webフレームワーク",
  doc_frameworks_angular_blurb:
    "美しいアプリケーションを楽しんで作る",
  doc_frameworks_ember_blurb: "野心的なWeb開発者のためのフレームワーク",
  doc_frameworks_react_blurb:
    "UIを作るためのJavaScriptライブラリ",
  doc_frameworks_vue_blurb: "進歩的なJavavScriptフレームワーク",
  doc_frameworks_ror_blurb: "設定より規約のWebフレームワーク",
  doc_frameworks_asp_blurb:
    "モダンなクラウドベースのアプリケーションを作るためのフレームワーク",
  doc_apis: "Node APIs",
  doc_apis_azure_blurb: "VSCodeから素早くビルドとデプロイ",
  doc_apis_feather_blurb:
    "リアルタイムアプリケーションとREST APIを作るためのフレームワーク",
  doc_apis_graphql_blurb: "GraphQLサーバーを即時に作成",
  doc_apis_nest_blurb:
    "効率的でスケーラブルなサーバサイドアプリケーションを作るための進歩的なNode.jsフレームワーク",
  doc_apis_node_blurb: "TypeScriptチームが作成したNodeJSのためのドキュメント付きのスタータープロジェクト",
  doc_apis_wechat_blurb: "TypeScriptでWeChat JSSDKを使う",
  doc_apis_loopback_blurb:
    "APIとマイクロサービスを作るための拡張性が高いNode.js TypeScriptフレームワーク",
  doc_apis_fastify_blurb: "高速でオーバーヘッドが少ないNode.jsのWebフレームワーク",
  doc_react: "React プロジェクト",
  doc_react_create_blurb: "モダンなWebアプリケーションをワンコマンドで",
  doc_react_gatsby_blurb:
    "超高速なWebサイトとWebアプリを作成",
  doc_react_next_blurb: "Reactのフレームワーク",
  doc_react_razzle_blurb:
    "設定不要のサーバサイドレンダリングされたユニバーサルなJavaScriptアプリケーション",
  doc_react_toolchains_title: "おすすめのツールチェーン",
  doc_react_toolchains_blurb: "Reactチームおすすめのツールチェーン",
  doc_apps: "ネイティブアプリケーションの作成",
  doc_apps_electron_blurb:
    "クロスプラットフォームのデスクトップアプリケーションをJavaScript、HTML、CSSで作成",
  doc_apps_expo_blurb: "最も早いアプリケーションの作成方法",
  doc_apps_react_native_blurb: "Learn once, write anywhere",
  doc_apps_native_script_blurb:
    "真にネイティブなモバイルアプリケーションを作るためのOSSフレームワーク",
  doc_apps_make_code_blurb:
    "魅力的なプロジェクトですべての学生の人生にコンピューターサイエンスをもたらす",
  doc_tooling: "ツール",
  doc_tooling_babel_blurb: "次の世代のJavaScriptを今使う",
  doc_tooling_parcel_blurb:
    "超高速な設定不要のWebアプリケーションバンドラー",
  doc_tooling_webpack_blurb: "アセット、スクリプト、画像、CSSのバンドラー",
  doc_learn: "すでにTypeScriptに詳しいですか？",
  doc_learn_3_5_release_notes_title: "リリースノート",
  doc_learn_handbook_blurb: "The TypeScript language reference", // TODO: Remove, unused
  doc_learn_d_ts_title: "d.tsガイド",
  doc_learn_d_ts_blurb: "JSの型をどのように宣言するかを学習する",
  doc_learn_playground_blurb: "オンラインでTypeScriptを探求、共有する",
}
